<template>
  <b-form-group description="Maak hier een koppeling met het onderdeel uit de oude prognose">
    <b-form-text>Import onderdeel</b-form-text>
    <b-select 
      :options="onderdelen" 
      :value="value" 
      @change="setValue"
    />
  </b-form-group>
</template>
<script>
export default {
  name: "OnderdeelImportKoppeling",
  mixins: [  ],
  props: {
    value: {type: Number, default: null}
  },
  data() {
    return {
      onderdelen: []
    };
  },
  mounted() {
    this.loadOnderdelen();
  },
  methods: {
    setValue(e) {
      this.$emit('input',e);
    },
    loadOnderdelen() {
      console.log("onderdelen...");
      var vm = this;
      this.$http
        .get("/onderdelen")
        .then(function(response) {
          console.dir(response.data);
          vm.onderdelen = response.data.onderdelen;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>